<template>
    <div v-if="statistics">        
		<div class="page-group-title"><span>{{statistics.name}}专题数据</span></div>
		<el-card class="statistics-box" header="下单转化数据">
			<el-row :gutter="20">
				<el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.pv}}</p><p class="color-info">专题页PV</p></el-col>
				<el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.uv}}</p><p class="color-info">专题页UV</p></el-col>
				<el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.activityClickPv}}</p><p class="color-info">专题下方演出点击数</p></el-col>
				<el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.activityClickUv}}</p><p class="color-info">专题下方演出点击人数</p></el-col>
				<el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.orderUserNum}}</p><p class="color-info">通过专题页下单人数</p></el-col>
				<el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.totalAmount}}</p><p class="color-info">通过专题页下单总金额</p></el-col>
			</el-row>
		</el-card> 
        <div class="page-list-box">
			<el-card class="statistics-box" header="演出下单明细">
				<el-table
					:data="statistics.activityDetails"
					border
					style="width: 100%"
					v-loading="listLoading"
					size="small"
					stripe
				>
					<el-table-column prop="activityId" label="演出id"></el-table-column>
					<el-table-column prop="title" label="演出名称" min-width="200" show-overflow-tooltip></el-table-column>
					<el-table-column prop="orderNum" label="订单数"></el-table-column>
					<el-table-column prop="userNum" label="下单人数"></el-table-column>
					<el-table-column prop="totalAmount" label="订单总金额"></el-table-column>
				</el-table>
			</el-card>
        </div>
		<div class="page-btns-box">
		    <el-button  type="primary" icon="el-icon-download" @click="download" :loading="downLoading" >导出数据</el-button>
		</div>
    </div>
</template>

<script>
import {downloadFileTmp} from '@/assets/js/commonApi.js';
export default {
    components:{},
    data(){
        
        return{
			id: this.$route.params.id,
            listLoading: false,             
            statistics: null,
			downLoading:false
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            
            this.$request({
                url: "/operational/theme/statistics",
                method: "POST",
                params: { id: this.id },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.statistics = result;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
            
        },
       //导出
       async download(){
           let filePath;
           this.downLoading = true;
           const res = await this.$request({
               url:'/operational/theme/statistics/export',
               method: 'post',
               params: { id: this.id },
           })
               .catch(err => {
                   this.$message({message: err.message, type: 'error'});
               })
           const{state,msg,result} = res.data;
           if(state == 1 && result){
               filePath = result.url;
           }else{
               this.downLoading = false;
               return this.$message.error(msg || '下载失败');
           }   
       
           await downloadFileTmp(filePath,this.statistics.name +'下单数据.'+this.$utils.getFileType(filePath));
       
           this.downLoading = false;
       },
       
    }
}
</script>

<style lang="scss" scoped>
.statistics-box{
    margin: 20px 0;
    .el-col{
        text-align: center;
        padding: 8px 0;
        .num{
            font-size: 16px;
            margin-bottom: 5px;
        }
    }
}
</style>